require('./files/designer');

require('../../css/web/show-more-description.css');
require('../../css/web/designer.css');